import React, { Component } from 'react';
import DropDownItem from './drop-down-item';
import Styles from '@src/framework/editor/src/page/index/components/editor/index.less';

/**
 * 悬挂工具栏的下拉菜单组件
 */
interface DropdownMenuProps {
    items: { id: string; name?: string }[];
    displayMode?: string;
    onSelectedItemCallback: (mode: string) => void;
}

interface DropdownMenuState {
    selectedIndex: number;
}

export default class DropdownMenu extends Component<DropdownMenuProps, DropdownMenuState> {
    public constructor(props: DropdownMenuProps) {
        super(props);
        this.state = {
            selectedIndex: 0,
        };
    }

    public componentDidMount() {
        this.getSelectedIndex({ displayMode: this.props.displayMode });
    }
    // eslint-disable-next-line camelcase
    public UNSAFE_componentWillReceiveProps(nextProps: DropdownMenuProps) {
        // 因为link-floatbar会更新state的config
        // 导致传下来的props也会更新一次才能拿到正确的值
        this.getSelectedIndex(nextProps);
    }

    public render() {
        return (
            <div className={Styles['link-floatbar-v2-dropdown-menu']}>
                <div className={Styles['link-floatbar-v2-dropdown-menu-listbox']}>
                    {
                        this.props.items.map((item, index) => {
                            if (item.name) {
                                return  <DropDownItem
                                    key={item.name}
                                    index={index}
                                    item={item}
                                    selectedIndex={this.state.selectedIndex}
                                    onSelectedItemCallback={this.handleSelectedItem.bind(this)}
                                >
                                </DropDownItem>;
                            }
                            return null;
                        })
                    }
                </div>
            </div>
        );
    }

    private getSelectedIndex = (nextProps: Partial<DropdownMenuProps>) => {
        const displayMode = nextProps.displayMode || nextProps.items?.[0].id;
        // eslint-disable-next-line array-callback-return
        this.props.items.map((_, i) => {
            if (_.id === displayMode) {
                this.setState({
                    selectedIndex: i,
                });
            }
        });
    };

    // 触发addonManager displayMode更换
    private handleSelectedItem(mode: string, index: number) {
        this.setState({
            selectedIndex: index,
        });
        this.props.onSelectedItemCallback(mode);
    }
}
